import {
  GET_LINEITEMS_RECORDS,
  GET_LINEITEMS_SUCCESS,
  GET_LINEITEMS_ERROR,
  UPDATE_LINEITEM_RECORD,
  UPDATE_LINEITEM_SUCCESS,
  UPDATE_LINEITEM_ERROR,
  DELETE_LINEITEM_RECORD,
  DELETE_LINEITEM_SUCCESS,
  DELETE_LINEITEM_ERROR,
  SHOW_CART_PROGRESS_RECORDS,
  UPDATE_LINE_ITEMS_STATE
} from "../actions";

export const getLineItems = (orderId, processCode, activityInfo) => {
  return {
    type: GET_LINEITEMS_RECORDS,
    payload: { orderId, processCode, activityInfo },
  };
};

export const getLineItemsSuccess = (recordList) => ({
  type: GET_LINEITEMS_SUCCESS,
  payload: recordList,
});

export const getLineItemsError = (message) => ({
  type: GET_LINEITEMS_ERROR,
  payload: { message },
});

export const updateLineItem = (lineItem, activityInfo) => {
  return {
    type: UPDATE_LINEITEM_RECORD,
    payload: { lineItem, activityInfo },
  };
};

export const updateLineItemSuccess = (recordListReturned) => ({
  type: UPDATE_LINEITEM_SUCCESS,
  payload: recordListReturned.lineItem,
});

export const updateLineItemError = (message) => ({
  type: UPDATE_LINEITEM_ERROR,
  payload: { message },
});

export const trashLineItem = (lineItem, activityInfo) => {
  return {
    type: DELETE_LINEITEM_RECORD,
    payload: { lineItem, activityInfo },
  };
};

export const showCartProgress = (progressIcon) => {

  return {
    type: SHOW_CART_PROGRESS_RECORDS,
    payload: { progressIcon },
  };
};

export const trashLineItemSuccess = (deletedLineItem) => ({
  type: DELETE_LINEITEM_SUCCESS,
  payload: deletedLineItem,
});

export const trashLineItemError = (message) => ({
  type: DELETE_LINEITEM_ERROR,
  payload: { message },
});

export const updateLineItemsState = (newState) => {
  return {
    type: UPDATE_LINE_ITEMS_STATE,
    payload: newState,
  };
};

